import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PrecisionInRecovery from "./sections/PrecisionInRecovery";
import TheResolveClinicalModel from "./sections/TheResolveClinicalModel";
import StructuredSupportPathways from "./sections/StructuredSupportPathways";
import AccountabilityOutcomes from "./sections/AccountabilityOutcomes";
import StartYourRecoveryJourney from "./sections/StartYourRecoveryJourney";
import Footer from "@/reusable_sections/Footer";
import Banner from "./sections/Banner";
export default function HomePage() {
  return <div>
      <Header />
      <PrecisionInRecovery />
      <StructuredSupportPathways />
      <TheResolveClinicalModel />
      <AccountabilityOutcomes />
      <StartYourRecoveryJourney />
      <Footer />
      <Banner />
    </div>;
}